export const GAF_LINKS = {
  PRIVACY_POLICY: 'https://www.gaf.energy/privacy-policy/',
  CALIFORNIA_PRIVACY: 'https://www.gaf.energy/gaf-energy-privacy-notice-at-collection/',
  TERMS_OF_SERVICE: 'https://www.gaf.energy/terms-of-service/',
  SITE_MAP: 'https://www.gaf.energy/sitemap/',
  APPLICANT_NOTICE:
    'https://www.gaf.energy/wp-content/uploads/2024/01/V3-GAF-Energy-Applicant-Privacy-Notice-2024.docx-1.pdf',
  YOUR_PRIVACY_CHOICES: 'https://standardindustries-privacy.relyance.ai/',
};
